export default __webpack_public_path__ + "static/media/ecosystem-of-partners.b3f46495.jpg";